import { use, useLayoutEffect, useState } from 'react';
import { useSidebarControl } from '@topcon/topcon-utils';

import { ReviewResultContext } from '../../providers/ReviewResultContext/review-result.context';
import {
  ReviewResultContextType,
  ReviewResultStatus,
} from '../../providers/ReviewResultContext/review-result.types';
import ServiceAgreementResult from '../../components/ServiceAgreement/Steps/ServiceAgreementResultStep';
import ServiceAgreementRequest from '../../components/ServiceAgreement/Steps/ServiceAgreementRequestStep';

function ServiceAgreement() {
  const { showInDesktopMode, setShowInDesktopMode } = useSidebarControl();
  const { result } = use<ReviewResultContextType>(ReviewResultContext);

  useLayoutEffect(() => {
    if (showInDesktopMode) setShowInDesktopMode(false);
    return () => {
      if (!showInDesktopMode) setShowInDesktopMode(true);
    };
  }, [showInDesktopMode, setShowInDesktopMode]);

  if (result !== null) return <ServiceAgreementResult />;
  return <ServiceAgreementRequest />;
}

function ServiceAgreementWrapper() {
  const [result, setResult] = useState<ReviewResultStatus | null>(null);
  return (
    <ReviewResultContext value={{ result, setResult }}>
      <ServiceAgreement />
    </ReviewResultContext>
  );
}

export default ServiceAgreementWrapper;
